import algoliasearch from "algoliasearch"
import { isBack } from "../../isBack"
import { isFrontDev } from "../../isFrontDev"

const ASearchKey = "59f16ff94863bdd978eb9fafca9ddebb"
const AAppId = "VN1P9U25CP"
const MissionIndexKey = isFrontDev ? "test_TB_MISSIONS" : "dev_TB_MISSIONS"
export const algolia = isBack ? {} : algoliasearch(AAppId, ASearchKey)
export const missionsIndex = isBack ? {} : algolia.initIndex(MissionIndexKey)
